export default "__VITE_ASSET__ed3925a9__"